import React from "react";
import { List, Pagination } from "antd";
import config from "appConfig";

import styles from "./listSavedSearchWeb.scss";
import SavedSearchItem from "./SavedSearchItem";
import { calculateTotalPagingCount } from "../../../../services";

const ListSavedSearchWeb = ({
  savedSearches,
  onDelete,
  onNotificationChange,
  onPageChange
}) => (
  <div className={styles.container}>
    <List
      itemLayout="horizontal"
      dataSource={savedSearches && savedSearches.data ? savedSearches.data : []}
      renderItem={item => (
        <SavedSearchItem
          item={item}
          onDelete={onDelete}
          onNotificationChange={onNotificationChange}
        />
      )}
    />
    {savedSearches && savedSearches.count > config.maxSavedSearchPerPage ? (
      <div className="child-center">
        <Pagination
          total={calculateTotalPagingCount(savedSearches.count, savedSearches.page)}
          current={savedSearches.page}
          pageSize={config.maxSavedSearchPerPage}
          onChange={onPageChange}
          className={styles.pagination}
        />
      </div>
    ) : null}
  </div>
);

ListSavedSearchWeb.defaultProps = {
  savedSearches: {}
};

export default ListSavedSearchWeb;



// WEBPACK FOOTER //
// ./src/containers/SavedSearchPage/ListSavedSearch/ListSavedSearchWeb/index.tsx